import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css?family=Roboto');
    @import url('https://fonts.googleapis.com/css?family=Ubuntu:700');

    body {
        padding: 0;
        margin: 0;
        font-family: -apple-system, system-ui, BlinkMacSystemFont, Roboto, sans-serif;
        background-color: #FAFAFA;
    }

    button {
        touch-action: manipulation;
    }
`;

export default GlobalStyle;
